<template>
  <div class="side-nav">
    <transition name="fade" mode="out-in">
      <img v-if="isMobile && !showFuncList" key="more" class="more" :src="cfg.ossDomain + '/wechat_hover.png'" @click="showFuncList = true">
      <ul v-else class="func-list" key="list">
        <li v-if="isMobile" class="close-wrapper" @click="showFuncList = false">
          <i class="el-icon-close close-icon"></i>
        </li>
        <li class="item">
        <div class="slide-layout">
          <div class="slide-wrapper">
            <div class="normal">
              <img class="icon" :src="cfg.ossDomain + '/phone.png'">
              <span class="text">小程序</span>
            </div>
            <div class="active">
              <img class="icon" :src="cfg.ossDomain + '/phone_hover.png'">
              <span class="text">小程序</span>
            </div>
          </div>
        </div>
        <!-- <img class="qr-code" :src="cfg.ossDomain + '/bxgz_qr.jpg'"> -->
      </li>
      <li class="item">
        <div class="slide-layout">
          <div class="slide-wrapper">
            <div class="normal">
              <img class="icon" :src="cfg.ossDomain + '/wechat.png'">
              <span class="text">公众号</span>
            </div>
            <div class="active">
              <img class="icon" :src="cfg.ossDomain + '/wechat_hover.png'">
              <span class="text">公众号</span>
            </div>
          </div>
        </div>
        <img class="qr-code" :src="cfg.ossDomain + '/wechat_qr.png'">
      </li>
      <li class="item">
        <div class="slide-layout">
          <div class="slide-wrapper">
            <div class="normal">
              <img class="icon" :src="cfg.ossDomain + '/weibo.png'">
              <span class="text">官方微博</span>
            </div>
            <a class="active" href="https://weibo.com/u/6889326358" target="_blank">
              <img class="icon" :src="cfg.ossDomain + '/weibo_hover.png'">
              <span class="text">官方微博</span>
            </a>
          </div>
        </div>
      </li>
      <a class="backup" :class="{ 'is-show': backupShow }" href="#">
        <img class="icon" :src="cfg.ossDomain + '/back_top.png'">
      </a>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backupShow: false,
      threshold: 0,
      showFuncList: false,
      isMobile: false
    }
  },
  mounted() {
    const el = document.querySelector('.side-bar-main');
    this.threshold = el ? el.offsetTop : 0;
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.showFuncList = true;
      }
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const shouldShow = scrollTop > this.threshold;

      // 仅当状态确实需要切换时才更新数据，避免无效渲染和布局抖动
      if (this.backupShow !== shouldShow) {
        this.backupShow = shouldShow;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.side-nav{
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  z-index: 9999;
  will-change: transform; /* 提升合成层，优化渲染性能 */
  .func-list{
    // padding-left: 134px;
    height: 304px;
    list-style: none;
    .item {
      position: relative;
      .slide-layout{
        width: 72px;
        overflow: hidden;
      }
      .slide-wrapper{
        position: relative;
        display: inline-flex;
        margin-bottom: 4px;
        transition: all .2s linear;
        .active,.normal{
          width: 72px;
          height: 72px;
          background: #FFFFFF;
          border: 1px solid #E5E5E5;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .icon{
            width: 36px;
            height: 36px;
          }
          .text{
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            margin-top: 4px;
            color: #999999;
          }
        }
        &:hover{
          transform: translateX(-72px);
        }
      }
      &:hover .qr-code{
        display: block !important;
      }
    }
    .backup {
      opacity: 0;
      visibility: hidden;
      &.is-show {
        opacity: 1;
        visibility: visible;
      }
      .icon{
        width: 72px;
        height: 72px;
      }
    }
    .qr-code{
      position: absolute;
      left: -134px;
      width: 130px;
      height: 130px;
      top: 0;
      display: none;
      transition: all .2s linear;
    }
  }
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 768px) {
  .side-nav{
    position: fixed;
    top: auto;
    min-height: 160px;
    bottom: 30%;
    right: 5px;
    transform: none;
    z-index: 9999;
    will-change: transform;
      .more {
      width: 40px;
      height: 40px;
      display: block;
      cursor: pointer;
    }
    .func-list{
      height: auto;
      position: relative;
      padding-bottom: 60px;
      .close-wrapper {
        display: flex;
        width: 48px;
        height: 48px;
        border: 1px solid #E5E5E5;
        right: 5px;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
        background-color: white;
        -webkit-tap-highlight-color: transparent;
        .close-icon {
          font-size: 24px;
          color: #999;
          cursor: pointer;
        }
      }
      list-style: none;
      .item {
        position: relative;
        .slide-layout{
          width: 50px;
          overflow: hidden;
        }
        .slide-wrapper{
          position: relative;
          display: inline-flex;
          margin-bottom: 4px;
          transition: all .2s linear;
          .active,.normal{
            width: 50px;
            height: 50px;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .icon{
              width: 25px;
              height: 25px;
            }
            .text{
              font-size: 12px;
              font-weight: 400;
              line-height: 16px;
              margin-top: 4px;
              color: #999999;
            }
          }
          &:hover{
            transform: translateX(-50px);
          }
        }
        &:hover .qr-code{
          display: block !important;
        }
      }
      .backup {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        opacity: 0;
        visibility: hidden;
        &.is-show {
          opacity: 1;
          visibility: visible;
        }
        .icon{
          width: 50px;
          height: 50px;
        }
      }
      .qr-code{
        position: absolute;
        left: -134px;
        width: 130px;
        height: 130px;
        top: 0;
        display: none;
        transition: all .2s linear;
      }
    }
  }
}
</style>
